"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const GearIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M2.568 8.59a1 1 0 000-1.18l-1.56-2.13A7.492 7.492 0 012.15 3.306l2.622.285A1 1 0 005.795 3L6.86.586a7.559 7.559 0 012.28 0L10.205 3a1 1 0 001.023.59l2.622-.284a7.491 7.491 0 011.14 1.974l-1.559 2.13a1 1 0 000 1.18l1.56 2.13a7.491 7.491 0 01-1.142 1.974l-2.622-.285a1 1 0 00-1.023.59L9.14 15.415a7.56 7.56 0 01-2.28 0L5.795 13a1 1 0 00-1.023-.59l-2.622.284a7.49 7.49 0 01-1.14-1.974l1.559-2.13zM8 10a2 2 0 110-4 2 2 0 010 4z",
    clipRule: "evenodd"
  })))
});
GearIcon.displayName = 'GearIcon';
var _default = exports.default = GearIcon;